import React from 'react';


const SectionScrollNavigator = ({ encounterID, activeID, setActiveID, hoveredItem, setHoveredItem, ...props }) => {
  let { defaultSelectedItems, isGroupNote } = props;
  let { historyofPresentIllness, reviewOfSystem, problems, prescriptions, supplements, vaccines, injections, labs, imaging, followUp, documents, additionalNotes } = defaultSelectedItems;
  const isDivider = (item) => ['Divider'].includes(item.name);
  const hasNoNavigationKeyword = (item) => !item.NavigationKeyword;
  const hideWidget = (item) => isGroupNote && item.IsWidget === 'true';

  const mainCustomTemplateItems = props?.mainCustomTemplateData?.[0]?.Data?.[0]?.items;

  // buildSectionItems now takes a templateIndex so IDs stay unique across
  // multiple custom templates. Format MUST match the DOM ids CustomNote/
  // CustomTemplateForm assign to each item's wrapping element, or hover/
  // click sync will silently break (id lookup miss, no error thrown).

  // FormattingTextField
  const htmlToText = (html = "") => {
    const div = document.createElement("div");
    div.innerHTML = html;
    return div.textContent?.replace(/\s+/g, " ").trim() || "";
  };

  const renderTooltip = (item, defaultLabel) => {
    const defaultLabelText = (item.NavigationKeyword || defaultLabel);

    if (item?.IsWidget === "true") {
      return (item.name || defaultLabelText);
    }

    if (item?.name === "Formatting Text") {
      return htmlToText(item.content) || defaultLabelText;
    }

    return (item.content || defaultLabelText);
  }
  const buildSectionItems = (items, sectionType, defaultLabel, templateIndex) => {
    // section type can be MCF(Main Custom Form Section) / CF(Custom Form Section)
    return (items || [])
      .map((item, index) =>
        (isDivider(item) || hasNoNavigationKeyword(item) || hideWidget(item))
          ? null
          : {
            id: `ref-${sectionType}${encounterID}-${templateIndex}-${index}`,
            label: item.NavigationKeyword || defaultLabel,
            tooltip: renderTooltip(item, defaultLabel),
          }
      )
      .filter(Boolean)
  }

  // Pair each custom template with its real position in the full array
  // (same rule as CustomNote/CustomTemplateForm) so templateIndex here
  // matches templateIndex there — this is what keeps the two independently
  // built ID strings aligned.
  const indexedCustomTemplates = (props?.customTemplateData || [])
    .map((template, originalIndex) => ({ template, originalIndex }));

  const sortByPlacement = (a, b) =>
    (a.template.PlacementIndex ?? a.originalIndex) - (b.template.PlacementIndex ?? b.originalIndex);

  const topCustomTemplateSections = indexedCustomTemplates
    .filter(({ template }) => template.InsertPosition === 'Top')
    .sort(sortByPlacement)
    .flatMap(({ template, originalIndex }) =>
      buildSectionItems(template?.Data?.[0]?.items, 'CF', 'CT', originalIndex)
    );

  const bottomCustomTemplateSections = indexedCustomTemplates
    .filter(({ template }) => template.InsertPosition !== 'Top') // default bucket
    .sort(sortByPlacement)
    .flatMap(({ template, originalIndex }) =>
      buildSectionItems(template?.Data?.[0]?.items, 'CF', 'CT', originalIndex)
    );

  // Main stays single-item — templateIndex fixed at 0, matching CustomNote.
  const mainCustomTemplateSections = buildSectionItems(mainCustomTemplateItems, 'MCF', 'MCT', 0);

  const sections = [
    ...topCustomTemplateSections,
    ...mainCustomTemplateSections,
    ...bottomCustomTemplateSections,
  ];
  // console.log("SECTION scrollNavIDsCustomTemplateForm mainNavigationKeywordList", sections)
  const handleScrollIntoView = (id) => {
    setActiveID(id);
    setHoveredItem('');
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
      //onNavigate?.(id); // Optional callback
    }
  };

  return (
    <>
      {sections.map((section, index) => (
        <>
          <div className="d-flex flex-column gap-5" key={index}>
            {section?.children?.length > 0 ?
              (<>
                <p
                  id={`vertical-bar-${section.id}`}
                  className={`heading text-center ${section.children
                      ? [section.id, ...section.children.map(c => c.id)].includes(activeID)
                        ? 'orange-drk'
                        : ''
                      : activeID === section.id ? 'orange-drk' : ''
                    }`}
                  onClick={() => handleScrollIntoView(section.heading)}
                >
                  {section.label}
                </p>
                {section?.children?.map((child) => (
                  <p
                    key={child.id}
                    id={`vertical-bar-${child.id}`}
                    className={`box font-m text ar-light-color ${activeID === child.id ? 'active' : ''
                      } ${hoveredItem === child.id ? 'active' : ''
                      }`}
                    onClick={() => handleScrollIntoView(child.id)}
                    title={section?.tooltip}
                  >
                    {child.label}
                  </p>
                ))}
              </>) :
              (<p
                key={section.id}
                id={`vertical-bar-${section.id}`}
                className={`box font-m text ar-light-color ${activeID === section.id ? 'active' : ''
                  } ${hoveredItem === section.id ? 'active' : ''
                  }`}
                onClick={() => handleScrollIntoView(section.id)}
                title={section?.tooltip}
              >
                {section.label}
              </p>)
            }
          </div>
        </>
      ))}
      {sections?.length === 0 && <div className='empty_section'></div>}
    </>
  );
};

export default SectionScrollNavigator;